export default "__VITE_ASSET__87c1df83__"